module.exports = __webpack_public_path__ + "static/media/Programming Languages.fef56159.jpg";